export const MAX_OLD_CONVERSATION_DAYS = 660;

export default {
  MAX_OLD_CONVERSATION_DAYS,
};
